import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cnaeReadAction from './cnaeRead.action.json' assert { type: 'json' }

const cnaeReadDefinition = defineReadAutoAction(cnaeReadAction, 'cnae')

export default cnaeReadDefinition
